export default "__VITE_ASSET__47823f61__"